// Contenu de la page « Calculateur de boissons mariage » (référencement). En
// français : la page vise les recherches Google françaises. Les chiffres des
// tableaux et de la FAQ viennent du même modèle que l'outil (drinksModel.ts).

export const REFERENCE_GUESTS = [50, 80, 100, 120, 150];

export const RULES = [
  {
    title: 'Vin d’honneur : 1 bouteille de champagne pour 3 invités',
    text: 'Comptez environ 2 flûtes par personne sur un cocktail d’1 h 30 à 2 h, plus un verre de blanc ou de rosé pour ceux qui préfèrent.',
  },
  {
    title: 'Dîner : 1 bouteille de vin pour 2 invités',
    text: 'Environ 3 verres par personne sur le repas, à répartir entre rouge et blanc selon le menu.',
  },
  {
    title: 'Dessert : 1 bouteille de champagne pour 6 invités',
    text: 'Une flûte par personne pour les discours, la pièce montée ou le gâteau.',
  },
  {
    title: 'Brunch : 1 bouteille pour 3 invités',
    text: 'Un à deux verres de rosé ou de blanc frais, souvent pour moins d’invités que la veille.',
  },
];

export const PAIRINGS = [
  {
    title: 'Au vin d’honneur',
    text: 'Champagne ou crémant, et un blanc ou un rosé frais et léger, faciles à boire debout, avec les pièces salées.',
  },
  {
    title: 'Au dîner',
    text: 'Un blanc pour l’entrée ou le poisson, un rouge pour la viande. Avec un menu tout poisson, un dîner au blanc seul fonctionne très bien.',
  },
  {
    title: 'Au dessert',
    text: 'Le champagne reste le classique ; un crémant ou un vin doux font aussi bien l’affaire avec la pièce montée.',
  },
  {
    title: 'Au brunch',
    text: 'Rosé et blanc frais, et de quoi faire des cocktails sans alcool pour les lendemains difficiles.',
  },
];

export const SAVINGS = [
  {
    title: 'Un crémant à la place du champagne',
    text: 'Au vin d’honneur, un bon crémant coûte souvent deux à trois fois moins cher, et peu d’invités font la différence.',
  },
  {
    title: 'Achetez en direct au domaine',
    text: 'Pour de grandes quantités, les vignerons font souvent des prix, et livrent parfois.',
  },
  {
    title: 'Négociez le droit de bouchon',
    text: 'Si vous apportez vos boissons, le traiteur facture souvent le service par bouteille : comparez avec ses propres vins.',
  },
  {
    title: 'Demandez si les bouteilles non ouvertes sont reprises',
    text: 'Certains cavistes et domaines reprennent les bouteilles intactes : de quoi prévoir large sans gaspiller.',
  },
];

export const FAQ_STATIC = [
  {
    q: 'Combien de verres dans une bouteille de vin ou de champagne ?',
    a: 'Une bouteille de 75 cl donne environ 6 verres de vin de 12,5 cl, et 6 à 7 flûtes de champagne. Le calculateur compte 6 verres par bouteille, pour rester prudent.',
  },
  {
    q: 'Faut-il compter les enfants ?',
    a: 'Non pour l’alcool : indiquez le nombre d’invités adultes. Prévoyez à part de l’eau, des jus et des softs, pour les enfants comme pour ceux qui conduisent.',
  },
  {
    q: 'Quelle marge prévoir ?',
    a: 'Autour de 10 %, déjà incluse dans le calculateur : une soirée qui se prolonge, des verres entamés et laissés, quelques invités de plus.',
  },
];
